// ✅ index.jsx con cookie de sesión middleware
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./msalConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const Root = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const start = async () => {
      try {
        console.log("🔁 Inicializando MSAL...");
        await msalInstance.initialize();

        console.log("🔄 Procesando redirección...");
        const response = await msalInstance.handleRedirectPromise();
        console.log("📥 Resultado de handleRedirectPromise:", response);

        const accounts = msalInstance.getAllAccounts();
        const tieneSesionMiddleware = document.cookie.includes("middleware_session=true");

        console.log("💬 Cookie de sesión middleware:", tieneSesionMiddleware);
        console.log("💬 Cuentas en MSAL:", accounts);

        if (response && response.account) {
          msalInstance.setActiveAccount(response.account);
          document.cookie = "middleware_session=true; path=/;";
        } else if (!tieneSesionMiddleware || accounts.length === 0) {
          console.log("🔁 Lanzando loginRedirect por falta de cookie o cuenta...");
          await msalInstance.loginRedirect(loginRequest);
          return;
        } else if (accounts.length === 1 && tieneSesionMiddleware) {
          msalInstance.setActiveAccount(accounts[0]);
        }

        setReady(true);
      } catch (err) {
        console.error("❌ Error en flujo de autenticación MSAL:", err);
        setReady(true);
      }
    };

    start();
  }, []);

  if (!ready) return <div>🔄 Cargando sesión...</div>;

  return <App msalInstance={msalInstance} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
